import { defineComponent as _defineComponent } from 'vue'
import { startCase } from "lodash";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JsonTable',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: string | number | Array<any> | Record<string, any>;
};




const valueType = computed(() => {
  const value = props.value;
  if (!value) {
    return "null";
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      return "array";
    } else {
      return "object";
    }
  } else {
    return typeof value;
  }
})



return { __sfc: true,props, valueType, startCase }
}

})